import { render, staticRenderFns } from "./detailsEleve.vue?vue&type=template&id=7b489303&"
import script from "./detailsEleve.vue?vue&type=script&lang=js&"
export * from "./detailsEleve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports